import { render, staticRenderFns } from "./CoverCompoundModal.vue?vue&type=template&id=c991151e&scoped=true"
import script from "./CoverCompoundModal.vue?vue&type=script&lang=js"
export * from "./CoverCompoundModal.vue?vue&type=script&lang=js"
import style0 from "./CoverCompoundModal.vue?vue&type=style&index=0&id=c991151e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c991151e",
  null
  
)

export default component.exports